import { colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';

export const AnchorBoxContainer = styled.div`
  a {
    text-decoration: none;
  }
`;

export const Container = styled.div<{ darkMode?: boolean }>`
  width: fit-content;
  padding: ${pxToRem(16)} ${pxToRem(24)};
  display: flex;
  align-items: center;

  border: ${pxToRem(1)} solid ${({ darkMode }) => (darkMode ? 'white' : 'black')};
  border-radius: ${pxToRem(10)};

  & span {
    margin-right: ${pxToRem(10)};
    font-family: ${fonts.regular};
    font-weight: 700;
    ${pxToCssFont(18, 24)}
    color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
  }
  & svg {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
  }
  & path {
    stroke: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)} !important;
    stroke-width: ${pxToRem(1.5)} !important;
  }

  :hover {
    background-color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
    & span {
      color: ${({ darkMode }) => (darkMode ? colors.$262626 : colors.$ffffff)};
    }
    & svg {
      ${({ darkMode }) => (darkMode ? colors.$262626 : colors.$ffffff)};
    }
    & path {
      stroke: ${({ darkMode }) => (darkMode ? colors.$262626 : colors.$ffffff)} !important;
    }
  }

  :active {
    border: 1px solid ${colors.$ffffff};
    background-color: ${colors.$7e7e7e};
    & span {
      color: ${colors.$ffffff};
    }
    & svg {
      ${({ darkMode }) => (darkMode ? colors.$262626 : colors.$ffffff)};
    }
    & path {
      stroke: ${colors.$ffffff} !important;
    }
  }
`;

export const CustomButton = styled.button`
  all: unset;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
`;

export const AnchorLabel = styled.span<{ darkMode?: boolean }>`
  color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
`;
